module.exports = __webpack_public_path__ + "../resources/images/formatpaintercursor-fca25bebfad3d9508f1007ad32f3fd7f.svg";